let base;
base = window.location.protocol + '//' + (process.env.NODE_IMG_DOMAIN || 'cdn.xinjngtech.com') + '/';
export default base;


// WEBPACK FOOTER //
// ./src/api/imgUrl.js